import {
  Input,
  Form,
  Typography,
  Image,
  Card,
  FormInstance,
  Button,
  Select,
  ConfigProvider,
  Row,
  Col,
} from "antd";
import Logo from "../../../../assets/images/osd_logo.png";
import { useEffect, useState } from "react";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

export interface Props {
  onChangeCurrentStep: (step: number) => void;
  currentStep: number;
  stepsLength: number;
  form: FormInstance;
  submitFormGeneral: (event: any) => void;
}
const EconnectStepThreePublic: React.FC<Props> = ({
  onChangeCurrentStep,
  currentStep,
  stepsLength,
  form,
  submitFormGeneral,
}): React.ReactElement => {
  // const [valueAttendeeType, setValueAttendeeType] = useState<string>("");
  // const [valueFieldofStudy, setValueFieldofStudy] = useState<string>("");
  // const [valuePurposeofAttendingS, setValuePurposeofAttendingS] =
  //   useState<string>("");
  // const [valuePurposeofAttending, setValuePurposeofAttending] =
  //   useState<string>("");
  // const [valueIndustry, setValueIndustry] = useState<string>("");

  // const onChangeSelect = (value: string) => {
  //   setValueAttendeeType(value);
  // };

  // const onChangeSelectFieldofStudy = (value: string) => {
  //   setValueFieldofStudy(value);
  // };

  // const onChangeSelectPurposeofAttending = (value: string) => {
  //   setValuePurposeofAttending(value);
  // };

  // const onChangeSelectPurposeofAttendingS = (value: string) => {
  //   setValuePurposeofAttendingS(value);
  // };

  // const onChangeSelectIndustry = (value: string) => {
  //   setValueIndustry(value);
  // };

  return (
    <div className="w-[353px]">
      <Row>
        <Col className=" w-full my-4">
          <Card>
            <br />
            <div className="flex justify-center pb-[20px]">
              <Image src={Logo} width={93} preview={false} />
            </div>
            <div className=" text-center">
              <Typography className="font-bold text-[16px] w-full text-[#160C65]">{`Registration Form`}</Typography>
            </div>
            <div>
              <ConfigProvider
                theme={{ components: { Form: { labelColor: "#160C65" } } }}
              >
                <Form
                  form={form}
                  onFinish={submitFormGeneral}
                  layout="vertical"
                  autoComplete="off"
                  className="w-full"
                >
                  <div className=" w-full  h-[calc(100vh-330px)] overflow-y-auto ">
                    <Form.Item
                      className=" m-1"
                      label={"Full Name"}
                      name={"fullname"}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter",
                        },
                      ]}
                    >
                      <Input placeholder="Text" />
                    </Form.Item>
                    <Form.Item
                      className=" m-1"
                      label={"Company Name"}
                      name={"companyName"}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter",
                        },
                      ]}
                    >
                      <Input placeholder="Text" />
                    </Form.Item>
                    <Form.Item
                      className=" m-1"
                      label={"Office Address"}
                      name={"officeAddress"}
                    >
                      <TextArea placeholder="address" />
                    </Form.Item>

                    <Form.Item
                      className=" m-1"
                      label={"Position/Job Title"}
                      name={"position"}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter",
                        },
                      ]}
                    >
                      <Input placeholder="Text" />
                    </Form.Item>
                    <Form.Item
                      className=" m-1"
                      label={"Email"}
                      name={"businessEmail"}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter",
                        },
                      ]}
                    >
                      <Input placeholder="example@email.com" type="email" />
                    </Form.Item>
                    <Form.Item
                      className=" m-1"
                      label={"Line ID"}
                      name={"lineId"}
                    >
                      <Input placeholder="Text" />
                    </Form.Item>
                    <div className="text-[#160C65] font-bold text-[16px]">
                      Business Information
                    </div>
                    <Form.Item
                      className=" m-1"
                      label={"Type of Business / Industry "}
                      name={"attendeeType"}
                      rules={[
                        {
                          required: true,
                          message: "Please Select",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Please Select"
                        options={[
                          {
                            value: "SME Business Owner",
                            label: "SME Business Owner",
                          },
                          {
                            value: "Influencer / Content Creator",
                            label: "Influencer / Content Creator",
                          },
                          {
                            value: "General person interested in technology",
                            label: "General person interested in technology",
                          },
                          { value: "Other", label: "Other" },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item
                      className=" m-1"
                      label={"Company Website or Facebook Page "}
                      name={"website"}
                    >
                      <Input placeholder="Text" />
                    </Form.Item>
                  </div>
                  <Form.Item>
                    <div className=" grid grid-cols-1 gap-2 justify-center items-center w-full pt-8">
                      {/* <div className="flex w-full gap-[5px]"> */}
                      {currentStep < stepsLength - 1 && currentStep === 2 && (
                        <div className="w-full">
                          <ConfigProvider
                            theme={{ token: { colorPrimary: "#160C65" } }}
                          >
                            <Button
                              htmlType="submit"
                              type="primary"
                              className="text-white  w-full  rounded-[5px]"
                              size="large"
                            >
                              Submit
                            </Button>
                          </ConfigProvider>
                        </div>
                      )}
                      {currentStep > 0 && currentStep === 2 && (
                        <div className="w-full">
                          <Button
                            className="rounded-[5px] w-full"
                            size="large"
                            onClick={() => onChangeCurrentStep(currentStep - 1)}
                          >
                            <ArrowLeftOutlined /> Back
                          </Button>
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                  </Form.Item>
                </Form>
              </ConfigProvider>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
export default EconnectStepThreePublic;
